import React, { useState, useEffect, useRef, useCallback, createRef } from 'react';
import bigShadow from '../../assets/images/bigshadow1.png';
const canvasEl = createRef<HTMLCanvasElement>();

interface Star {
  draw(): void;
}
function render(el: HTMLCanvasElement, width: number, height: number) {
  let canvas = el,
    ctx = canvas.getContext('2d')!,
    w = (canvas.width = width),
    h = (canvas.height = height),
    hue = 217,
    stars: Star[] = [],
    count = 0,
    maxStars = 1400;

  // Thanks @jackrugile for the performance tip! https://codepen.io/jackrugile/pen/BjBGoM
  // Cache gradient
  var canvas2 = document.createElement('canvas'),
    ctx2 = canvas2.getContext('2d')!;
  canvas2.width = 100;
  canvas2.height = 100;
  var half = canvas2.width / 2,
    gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
  gradient2.addColorStop(0.025, 'rgba(255,255,255,.1)');
  // gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)');
  gradient2.addColorStop(0.09, 'hsl(' + hue + ', 50%, 0%)');
  // gradient2.addColorStop(1, 'hsl(' + hue + ', 10%, 0%)');

  ctx2.fillStyle = gradient2;
  ctx2.beginPath();
  ctx2.arc(half, half, half, 0, Math.PI * 2);
  ctx2.fill();

  // End cache

  function random(min: number, max?: number) {
    if (arguments.length < 2) {
      max = min;
      min = 0;
    }

    if (min > max!) {
      var hold = max!;
      max = min;
      min = hold;
    }

    return Math.floor(Math.random() * (max! - min + 1)) + min;
  }

  function maxOrbit(x: number, y: number) {
    var max = Math.max(x, y),
      diameter = Math.round(Math.sqrt(max * max + max * max));
    return diameter / 2;
  }

  var Star = function() {
    this.orbitRadius = random(maxOrbit(w, h));
    this.radius = random(60, this.orbitRadius) / 12;
    this.orbitX = w / 2;
    this.orbitY = h / 2;
    this.timePassed = random(0, maxStars);
    // this.speed = random(this.orbitRadius) / 50000;
    this.speed = 0.0004;
    // this.alpha = random(2, 10) / 10;
    this.alpha = 0.8;

    count++;
    stars[count] = this;
  };

  Star.prototype.draw = function() {
    var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
      y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
      twinkle = random(100);

    if (twinkle === 1 && this.alpha > 0) {
      this.alpha -= 0.05;
    } else if (twinkle === 2 && this.alpha < 1) {
      this.alpha += 0.05;
    }

    ctx.globalAlpha = this.alpha;
    ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius);
    this.timePassed += this.speed;
  };

  for (var i = 0; i < maxStars; i++) {
    // @ts-ignore
    new Star();
  }

  var imgObj = new Image();
  imgObj.src = bigShadow;
  let imageSrc: any;
  //待图片加载完后，将其显示在canvas上
  imgObj.onload = function() {
    imageSrc = this;
    animation();
  };

  let rafId: number;
  function animation() {
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 0.8;
    if (imageSrc) ctx.drawImage(imageSrc, 0, 0, w, h);
    else ctx.fillStyle = 'rgb(5, 17, 24)';

    // ctx.fillRect(0, 0, w, h);

    ctx.globalCompositeOperation = 'lighter';
    for (var i = 1, l = stars.length; i < l; i++) {
      stars[i].draw();
    }

    rafId = window.requestAnimationFrame(animation);
  }

  return () => cancelAnimationFrame(rafId);
}

export function StarBackground({ width, height }: { width: number; height: number }) {
  useEffect(() => {
    let cancel;
    if (canvasEl.current) {
      cancel = render(canvasEl.current, width, height);
    }
    return cancel;
  }, [width, height]);
  return <canvas ref={canvasEl} width={width} height={height} style={{ position: 'absolute', left: 0, top: 0, zIndex: 0 }}></canvas>;
}
